import React, { useState, useCallback } from "react";
import { firebaseAuth } from "../../../config/firebase";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import AddIcon from "@material-ui/icons/Add";
import { lighten } from "@material-ui/core/styles";
import styled from "styled-components";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import { CSSTransition } from 'react-transition-group';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';

const HeaderWrapper = styled.div`
  display: flex;
  background-color: #0155aa;
  min-height: 70px;
  left: 260px;
  right: 0;
  z-index: 2;
  padding-right: 20px;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  .menu {
    li {
      padding: 0 20px;
      display: inline-block;
      a {
        color: #777;
        text-decoration: none;
        text-transform: uppercase;
        font-size: 14px;
        &:hover {
          color: #444;
          font-weight: 500;
        }
      }
    }
  }
  .add-article {
    margin-left: 20px;
    display: flex;
    justify-content: center;

    &:hover {
      background-color: ${lighten("#0155aa", 0.1)};
      border-radius: 5px;
    }
    svg {
      font-size: 1.3rem;
    }
    span {
      font-size: 12px;
      text-transform: uppercase;
      font-weight: bold;
      margin: 3px 0 0 5px;

    }
    a {
      padding: 10px;
      color: white;
      display: flex;
      align-items: center;
    }
  }
  .user-menu {
    position: relative;
    padding-top: 6px;
    &__avatar {
      display: flex;
      align-items: center;
      > span {
        font-size: 12px;
        font-weight: bold;
        color: white;
        margin-right: 12px;
      }
      img {
        max-width: 40px;
        border-radius: 50%;
        transition: 0.4s;
        border: 3px solid #f2f2f2;
        &:hover {
          cursor: pointer;
          border: 3px solid white;
        }
      }
    }
    .submenu {
      position: absolute;
      width: 220px;
      background: white;
      box-shadow: 0 0 5px #999;
      height: 120px;
      right: 0;
      padding: 20px;
      > li {
          display: flex;
          padding: 0;
          align-items: center;
          margin: 16px 0;
          svg {
            height: 22px;
            margin-right: 8px;
          }
          span {
            display: block;
            font-size: 12px;
            color: #555;
            text-transform: uppercase;
            &:hover {
              color: #111;
            }
          }
        }
    }
  }
`;

const Header = () => {
  const [submenuActive, setSubmenuActive] = useState(false);
  const user = useSelector((store) => store.user);
  const dispatch = useDispatch();

  const startLogout = useCallback(() => {
    firebaseAuth
      .signOut()
      .then(() => dispatch({ type: "LOGOUT_USER" }))
      .catch((e) => {
        console.log(e);
      });
  }, [dispatch]);

  return (
    <HeaderWrapper>
      <div className="add-article">
        <Link to="/adicionar-artigo">
          <AddIcon />
          <span>Novo artigo</span>
        </Link>
      </div>
      <div className="menu">
        <div className="user-menu">
          <div className="user-menu__avatar">
            <span>Olá, {user.name.split(" ")[0]}</span>
            <img
              src={user.image}
              onClick={() => setSubmenuActive(!submenuActive)}
              alt={user.name}
            />
          </div>
          <CSSTransition
          in={submenuActive}
          timeout={300}
          classNames="fade"
          unmountOnExit
          >
            <ul className="submenu">
              <li>
                <AccountCircleIcon />
                <Link to="/meu-perfil">
                  Meu Perfil
                </Link>
              </li>
              <li>
                <ExitToAppIcon />
                <span onClick={startLogout} style={{ cursor: "pointer" }}>
                  Sair
                </span>
              </li>
            </ul>
          </CSSTransition>
        </div>
      </div>
    </HeaderWrapper>
  );
};

export default Header;
